import { useQuery } from 'react-query'

import { DetailedUser } from '@webapp/platform/iam/entities/DetailedUser'
import { userQueryConfig } from '@webapp/platform/iam/query-configs/user'

// Reuses the iam domain's existing repository + query key (ADR-6/8) —
// GET /api/v3/users/{id}/, the v3 replacement for Angular's v2 envelope
// (HLD Open Question). `enabled` lets the config-driven detail FS call
// all three header hooks unconditionally (rules-of-hooks).
export const useQueryUserDetailHeader = (userId: number, enabled = true) => {
  const { data, isFetching } = useQuery({
    ...userQueryConfig.getDetails(userId),
    enabled,
  })

  return {
    user: data ? new DetailedUser(data.data) : null,
    isLoading: isFetching,
  }
}
